import React from 'react'
import { Layout } from 'antd';
import NavigationContext from '@contexts/NavigationContext'
import NavigationReducer from '@contexts/NavigationReducer'
import { StateProvider } from '@contexts/StateProvider'

const { Content } = Layout;

const DocumentLayout = ({ children }) => {
    return (
        <StateProvider initialState={NavigationContext} reducer={NavigationReducer}>
            <Layout className="nw-page">
                <Content style={{ marginTop: 60 }}>
                    {children}
                </Content>
            </Layout>
        </StateProvider>
    )
};

export default DocumentLayout;
